import React from 'react';
import PropTypes from 'prop-types';

class Track extends React.Component {
  isCurrentTrack = () => this.props.current.track && this.props.current.track.chunk === this.props.track.chunk;
  isInProgress = () => this.props.current.inProgress && this.isCurrentTrack();
  calcProgressBarWidth() {
    if (this.props.track.duration && this.props.track.progress) {
      return `${this.props.track.progress * 100 / this.props.track.duration}%`;
    } else {
      return "0px";
    }
  }

  render() {
    return (
      <li
        className={`bg-${this.isCurrentTrack() ? 'white' : 'grey'} h-10 leading-10 w-16 rounded-full text-center text-lg font-bold inline-block align-middle mr-2 my-1 relative overflow-hidden group transition duration-100 hover:bg-white cursor-pointer`}
        onClick={() => this.isInProgress() ? this.props.toggleListening(this.props.song) : this.props.toggleListening(this.props.song, this.props.track)}
      >
        <div className="relative z-10">
          <button type="button" className="bg-black-mid rounded-full h-5 w-5 leading-5 text-grey text-center mr-2 inline-block align-middle transition duration-100 group-hover:text-white group-hover:inline-block" style={{ fontSize: "0.5em", marginTop: "-0.1em" }}>
            <i className={`fas fa-${this.isInProgress() ? 'pause' : 'play'} inline-block align-middle`} style={{ marginRight: this.isInProgress() ? "" : "-0.1em" }}></i>
          </button>
          <span className="inline-block align-middle">{this.props.index}</span>
        </div>
        <div className="absolute inset-0 bg-success z-0 transition duration-100 max-w-full" style={{ width: this.calcProgressBarWidth() }}></div>
      </li>
    );
  }
}

Track.propTypes = {
  current: PropTypes.object.isRequired,
  song: PropTypes.number,
  index: PropTypes.number,
  track: PropTypes.object,
  toggleListening: PropTypes.func,
};

Track.defaultProps = {
  toggleListening: () => {}
};

export default Track;
